<div *ngIf="reportType == 'YeneBakiJahiratReport'">

    <div class="report-container" [class.condensed-report]="startDate && endDate" id="print-section">

        <div class="report-header">
            <h2>जाहिरात येणे बाकी - {{ offRepName }}</h2>
            <div class="header-dates">
                <p>दिनांक: {{ currentDate | date:'dd-MM-yyyy' }}</p>
                <p>कालावधी: {{ startDate | date:'dd-MM-yyyy' }} ते {{ endDate | date:'dd-MM-yyyy' }}</p>
            </div>
        </div>

        <!-- Loading -->
        <div *ngIf="isLoading" style="text-align:center; padding: 30px;">
            <mat-spinner diameter="40"></mat-spinner>
            <p>डेटा लोड होत आहे...</p>
        </div>

        <!-- No data -->
        <div *ngIf="!isLoading && onlyOutstandingVB.length === 0" style="text-align:center; padding:30px;">
            <p>कोणताही डेटा सापडला नाही.</p>
        </div>

        <!-- Scroll wrapper added here -->
        <div class="table-scroll-wrapper" *ngIf="!isLoading && onlyOutstandingVB.length > 0">
            <table class="outstanding-table">
                <thead>
                    <tr>
                        <th rowspan="2">प्रतिनिधी</th>

                        <!-- Early years grouped header — 2 cols per year (amount + %) -->
                        <!-- In your thead, first row — add width to the early years grouped header -->
                        <th [attr.colspan]="earlyYears.length * 2" *ngIf="earlyYears.length > 0"
                            style="text-align:center; width: auto;">
                            {{ getYearShort(earlyYears[0], earlyYears[earlyYears.length - 1]) }}
                        </th>
                        <th rowspan="2" class="grey-cell" *ngIf="earlyYears.length > 0">
                            एकूण<br>({{ getYearShort(earlyYears[0], earlyYears[earlyYears.length-1]) }})
                        </th>

                        <!-- Recent years — 2 cols per year (amount + %) -->
                        <ng-container *ngFor="let year of recentYears">
                            <th colspan="2">{{ year }}</th>
                        </ng-container>

                        <th rowspan="2" class="grey-cell">एकूण</th>
                    </tr>
                    <tr>
                        <!-- Sub-headers for early years -->
                        <ng-container *ngFor="let year of earlyYears">
                            <th>{{ year }}</th>
                            <th class="pct-header">%</th>
                        </ng-container>

                        <!-- Sub-headers for recent years -->
                        <ng-container *ngFor="let year of recentYears; let i = index">
                            <th>{{ i + 1 }}</th>
                            <th class="pct-header">%</th>
                        </ng-container>
                    </tr>
                </thead>
                <tbody>

                    <ng-container *ngFor="let off of onlyOutstandingVB; let oi = index">

                        <!-- Row 1: Outstanding amounts -->
                        <tr class="office-total-row">
                            <td style="font-size: 14px;">
                                <strong>{{ oi + 1 }}. {{ off.off_rep_name }}</strong>
                            </td>

                            <!-- Early year outstanding + % (% NOT bold) -->
                            <ng-container *ngFor="let year of earlyYears">
                                <td class="text-right">
                                    <strong>{{ formatCurrency(getOffRepTotal(off, year)) }}</strong>
                                </td>
                                <td class="text-right pct-cell">
                                    {{ formatPercent(getOffRepTotal(off, year), getOffRepBilling(off, year)) }}
                                </td>
                            </ng-container>

                            <!-- Early years subtotal -->
                            <td class="text-right grey-cell" *ngIf="earlyYears.length > 0">
                                <strong>{{ formatCurrency(getOffRepEarlyTotal(off)) }}</strong>
                            </td>

                            <!-- Recent year outstanding + % (% NOT bold) -->
                            <ng-container *ngFor="let year of recentYears">
                                <td class="text-right">
                                    <strong>{{ formatCurrency(getOffRepTotal(off, year)) }}</strong>
                                </td>
                                <td class="text-right pct-cell">
                                    {{ formatPercent(getOffRepTotal(off, year), getOffRepBilling(off, year)) }}
                                </td>
                            </ng-container>

                            <!-- Grand total -->
                            <td class="text-right grey-cell">
                                <strong>{{ formatCurrency(getOffRepGrandTotal(off)) }}</strong>
                            </td>
                        </tr>

                        <!-- Row 2: Billing amounts (below outstanding) -->
                        <tr class="billing-row">
                            <td style="font-size: 11px; color: #e7e4e4; text-align: right;">
                                &nbsp;&nbsp;&nbsp; एकूण जाहिरात व्यवसाय
                            </td>

                            <!-- Early year billing -->
                            <ng-container *ngFor="let year of earlyYears">
                                <td class="text-right" colspan="2">
                                    {{ formatCurrency(getOffRepBilling(off, year)) }}
                                </td>
                            </ng-container>

                            <!-- Early years billing subtotal -->
                            <td class="text-right grey-cell" *ngIf="earlyYears.length > 0">
                                {{ formatCurrency(getOffRepEarlyBilling(off)) }}
                            </td>

                            <!-- Recent year billing -->
                            <ng-container *ngFor="let year of recentYears">
                                <td class="text-right" colspan="2">
                                    {{ formatCurrency(getOffRepBilling(off, year)) }}
                                </td>
                            </ng-container>

                            <!-- Grand billing total -->
                            <td class="text-right grey-cell">
                                {{ formatCurrency(getOffRepGrandBilling(off)) }}
                            </td>
                        </tr>

                    </ng-container>

                    <!-- Grand Total row -->
                    <tr class="grand-total-row">
                        <td><strong>एकूण (सर्व)</strong></td>

                        <!-- Early year grand totals + % (% NOT bold) -->
                        <ng-container *ngFor="let year of earlyYears">
                            <td class="text-right">
                                <strong>{{ formatCurrency(getGrandTotal(year)) }}</strong>
                            </td>
                            <td class="text-right pct-cell">
                                {{ formatPercent(getGrandTotal(year), getGrandBilling(year)) }}
                            </td>
                        </ng-container>

                        <td class="text-right grey-cell" *ngIf="earlyYears.length > 0">
                            <strong>{{ formatCurrency(getGrandEarlyTotal()) }}</strong>
                        </td>

                        <!-- Recent year grand totals + % (% NOT bold) -->
                        <ng-container *ngFor="let year of recentYears">
                            <td class="text-right">
                                <strong>{{ formatCurrency(getGrandTotal(year)) }}</strong>
                            </td>
                            <td class="text-right pct-cell">
                                {{ formatPercent(getGrandTotal(year), getGrandBilling(year)) }}
                            </td>
                        </ng-container>

                        <td class="text-right grey-cell">
                            <strong>{{ formatCurrency(getGrandOverallTotal()) }}</strong>
                        </td>
                    </tr>

                    <!-- Grand Billing row (below grand total) -->
                    <tr class="grand-billing-row" style="text-align: right;">
                        <td><strong>एकुन जाहिरात व्यवसाय</strong></td>

                        <!-- Early year grand billing -->
                        <ng-container *ngFor="let year of earlyYears">
                            <td class="text-right" colspan="2">
                                <strong>{{ formatCurrency(getGrandBilling(year)) }}</strong>
                            </td>
                        </ng-container>

                        <td class="text-right grey-cell" *ngIf="earlyYears.length > 0">
                            <strong>{{ formatCurrency(getGrandEarlyBilling()) }}</strong>
                        </td>

                        <!-- Recent year grand billing -->
                        <ng-container *ngFor="let year of recentYears">
                            <td class="text-right" colspan="2">
                                <strong>{{ formatCurrency(getGrandBilling(year)) }}</strong>
                            </td>
                        </ng-container>

                        <td class="text-right grey-cell">
                            <strong>{{ formatCurrency(getGrandOverallBilling()) }}</strong>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>

    </div>

    <div class="actions noPrint">
        <button mat-raised-button color="primary" (click)="exportExcel('Outstanding_Report')">Export Excel</button>
        <button mat-raised-button color="accent" printSectionId="print-section" (click)="printA4Landscape()">Print
            Report</button>
        <button class="btn btn-close noPrint" mat-button mat-dialog-close>
            <mat-icon>close</mat-icon>
            Close
        </button>
    </div>

</div>